import styled from "styled-components";

import { Icon_Drag } from "../../styles/icons.jsx";
import { Group as PanelGroup, Panel, Separator as PanelResizeHandle } from "react-resizable-panels";

const StyledHandle = styled(PanelResizeHandle)`
  position: relative;
  width: 0.5rem;
  margin-inline: 0.25rem;
  background-color: rgba(128, 128, 128, 0.1);
  :hover {
    background-color: ${({ theme }) => theme.area.highBg};
  }

`
const HandleIcon = styled.div`
    position:absolute;
    top:50%;
    z-index: 10;
    left: 50%;
    transform: translate(-50%, -50%);
`

const ResizeHandle = () => {
  return (
    <StyledHandle><HandleIcon>{Icon_Drag}</HandleIcon></StyledHandle>
  )
}

export {ResizeHandle, PanelGroup, Panel}

